module.exports = __webpack_public_path__ + "static/media/unavailable.4c0122c6.png";